import React, { FC } from 'react';
import { Virtuoso } from 'react-virtuoso';

import { TableLedgerItemColumn } from '../../../services';
import LedgerCard from './ledger-card';

type LedgerCardsProps = {
  data: TableLedgerItemColumn[];
  itemsCollapsed: { [key: string]: boolean };
  setItemCollapse: (itemId: string) => void;
};

const LedgerCards: FC<LedgerCardsProps> = ({ data, itemsCollapsed, setItemCollapse }) => (
  <Virtuoso
    style={{ height: 'calc(100vh - 240px)' }}
    data={data}
    overscan={5}
    itemContent={(index, item) => (
      <LedgerCard
        key={item.id}
        row={item}
        isOpen={!!itemsCollapsed[item.id]}
        onToggle={() => setItemCollapse(item.id)}
      />
    )}
  />
);

export default LedgerCards;
